import { render, staticRenderFns } from "./RA_EnemyAI.vue?vue&type=template&id=c53b3396&scoped=true&"
import script from "./RA_EnemyAI.vue?vue&type=script&lang=ts&"
export * from "./RA_EnemyAI.vue?vue&type=script&lang=ts&"
import style0 from "./RA_EnemyAI.vue?vue&type=style&index=0&id=c53b3396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53b3396",
  null
  
)

export default component.exports